module.exports = __webpack_public_path__ + "static/img/rectangle.a7cd5431.svg";